<script setup lang="ts">
// 初始化主题（防闪烁逻辑已抽离至 composables）
useThemeInit();

// 路由切换 loading 状态
const isLoading = ref(false)
const nuxtApp = useNuxtApp()

// 路由开始切换时显示 loading
nuxtApp.hook('page:start', () => {
  isLoading.value = true
})

// 路由切换完成时隐藏 loading
nuxtApp.hook('page:finish', () => {
  isLoading.value = false
})
</script>

<template>
  <div>
    <!-- 路由切换 loading 遮罩 -->
    <Transition name="fade">
      <div v-if="isLoading" class="route-loading">
        <svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" width="50px" height="50px" viewBox="0 0 50 50" style="enable-background:new 0 0 50 50" xml:space="preserve">
    <path fill="#5B6FB5" d="M43.935,25.145c0-10.318-8.364-18.683-18.683-18.683c-10.318,0-18.683,8.365-18.683,18.683h4.068c0-8.071,6.543-14.615,14.615-14.615c8.072,0,14.615,6.543,14.615,14.615H43.935z" transform="rotate(275.098 25 25)">
        <animateTransform attributeType="xml" attributeName="transform" type="rotate" from="0 25 25" to="360 25 25" dur=".8s" repeatCount="indefinite"></animateTransform>
    </path>
</svg>
      </div>
    </Transition>
    
    <!-- 顶部加载进度条，给用户更明确的加载感知 -->
    <NuxtLoadingIndicator color="#575757" :height="5" />

    <!-- 给视障人士专用辅助组件NuxtRouteAnnouncer -->
    <NuxtRouteAnnouncer />
    <NuxtLayout>
      <NuxtPage :key="$route.fullPath" />
    </NuxtLayout>
  </div>
</template>

<style>
/* Loading 遮罩 */
.route-loading {
  position: fixed;
  inset: 0;
  z-index: 9999;
  display: flex;
  align-items: center;
  justify-content: center;
  background: rgba(255, 255, 255, 0.8);
  backdrop-filter: blur(2px);
}

@media (prefers-color-scheme: dark) {
  .route-loading {
    background: rgba(0, 0, 0, 0.8);
  }
}

.loading-spinner {
  display: block; /* 确保是块级元素 */
  width: 48px;
  height: 48px;
  border: 4px solid #f3f3f3;
  border-top: 4px solid #3b82f6;
  border-radius: 50%;
  animation: loader-spin 1s linear infinite; /* 改个名字避免冲突 */
  will-change: transform; /* 性能优化 */
}

@media (prefers-color-scheme: dark) {
  .loading-spinner {
    border-color: #333;
    border-top-color: #60a5fa;
  }
}

@keyframes loader-spin {
  from { transform: rotate(0deg); }
  to { transform: rotate(360deg); }
}

/* 淡入淡出动画 */
.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.15s ease;
}

.fade-enter-from,
.fade-leave-to {
  opacity: 0;
}
</style>

